// Remove all spaces from a phone number
export const removeSpacesFromString = async (str: string) => {
  return str.replace(/\s+/g, "");
};

// Check if email is valid
export const isEmailValid = (email: string) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return regex.test(email);
};

export const isValidUrl = (str: string) => {
  const pattern = new RegExp(
    "^([a-zA-Z]+:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i",
  );
  return pattern.test(str);
};

export const replaceNon7BitChars = (text: string) => {
  const sevenBitMap = {
      //'à': 'a',
      //'ä': 'ae',
      'â': 'a',
      'ç': 'c',
      //'é': 'e',
      //'è': 'e',
      'ë': 'e',
      'ê': 'e',
      'ï': 'i',
      'î': 'i',
      'ì': 'i',
      'ô': 'o',
      'ö': 'o',
      'ò': 'o',
      'ù': 'u',
      'ü': 'u',
      'û': 'u',
      'ÿ': 'y',
      'ñ': 'n',
      'ß': 'ss',
      'œ': 'oe',
      'æ': 'ae',
      '€': 'E',
      'Å': 'A',
      'Ä': 'A',
      'Æ': 'AE',
      'Ö': 'O',
      'Ñ': 'N',
      'Ü': 'U',
      'Ø': 'O',
      // Add more?
  };

  return text.split('').map((char: string) => {
      return sevenBitMap[char as keyof typeof sevenBitMap] || char;
  }).join('');
}

export const getTopicIdFromUrl = async () => {
  try {
    const url = window.location.href;
    const aUrl = url.split("/");
    const iTopic = aUrl.indexOf("topic");
    return aUrl[iTopic + 1];
  } catch (error) {
    return null;
  }
};

export const capitalize = (s: string) => {
  // Garde volontaire : les appelants passent des valeurs issues d'optional
  // chaining (`subscription.timezone?.city` dans profile/customization.jsx),
  // donc `undefined` arrive reellement ici. Sans ce garde, `s[0]` leve un
  // TypeError pendant le rendu et fait tomber la page entiere — le `?.` du site
  // d'appel donnait l'illusion d'etre defensif alors que le crash se produisait
  // juste apres.
  if (!s) return '';
  return s[0].toUpperCase() + s.slice(1);
};

export const cleanPhoneNumber = (number: string) => {
  let cleaned = number;

  // #1 remove all non digits
  cleaned = number.replace(/\D/g, "");

  // #2 ...

  // #3 ...

  return cleaned;
};

export const printToConsoleIfLocalhost = (message: any) => {
  if (window.location.hostname === "localhost") {
    console.log(message);
  }
};

// get tag color by interest level
export const getTagColor = (interestLevel: string) => {
  switch (interestLevel) {
  case 'Intéressé':
    return 'green';
  case 'En réflexion':
    return 'purple';
  case 'Inactif': // Pas intéressé
    return 'orange';
  case 'À venir':
    return '#b7b7b79a';
  case 'Sans réponse':
    return 'yellow';
  default:
    return 'blue';
  }
};

export const genPassword = () => {
  // Generate a 14 characters password with at least one lowercase, one uppercase, one digit and one special character
  const lowercase = 'abcdefghkmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const digits = '23456789';
  const special = '!@#&+?';

  // Generate it
  let password = '';
  for (let i = 0; i < 14; i++) {
    const type = Math.floor(Math.random() * 4);
    switch (type) {
      case 0:
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
        break;
      case 1:
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
        break;
      case 2:
        password += digits[Math.floor(Math.random() * digits.length)];
        break;
      case 3:
        password += special[Math.floor(Math.random() * special.length)];
        break;
    }
  }
  return(password);
};

export const isPasswordRobust = (password: string) => {
  const hasNumber = /\d/.test(password);
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasOther = /[^a-zA-Z0-9]/.test(password);

  if (password.length < 10 || !hasNumber || !hasLetter || !hasOther) {
    return false;
  }
  return true;
};
